/* ═══════════════════════════════════════
   MONORĀ THEME — theme.js
═══════════════════════════════════════ */

// ── CART AJAX API ──
const MonoraCart = {
  async get() {
    const r = await fetch('/cart.js'); return r.json();
  },
  async add(items) {
    const r = await fetch('/cart/add.js', {
      method: 'POST', headers: {'Content-Type':'application/json'},
      body: JSON.stringify({items})
    }); return r.json();
  },
  async change(line, qty) {
    const r = await fetch('/cart/change.js', {
      method: 'POST', headers: {'Content-Type':'application/json'},
      body: JSON.stringify({line, quantity: qty})
    }); return r.json();
  }
};

function fmtMoney(cents) {
  return '₹' + (cents / 100).toLocaleString('en-IN');
}

// ── CART DRAWER ──
async function openCartDrawer() {
  document.getElementById('cdover').classList.add('open');
  document.getElementById('cd').classList.add('open');
  await refreshCartDrawer();
}
function closeCartDrawer() {
  document.getElementById('cdover').classList.remove('open');
  document.getElementById('cd').classList.remove('open');
}
async function refreshCartDrawer() {
  const cart = await MonoraCart.get();
  renderCartDrawer(cart);
  updateCartBadge(cart.item_count);
}
function updateCartBadge(count) {
  const b = document.getElementById('cartBadge');
  if (b) { b.textContent = count; b.style.display = count > 0 ? 'flex' : 'none'; }
}
function renderCartDrawer(cart) {
  const items = document.getElementById('cdItems');
  const footer = document.getElementById('cdFooter');
  if (!items) return;
  if (cart.item_count === 0) {
    items.innerHTML = '<div class="cdempty"><p>Your bag is empty.</p><a href="/collections/all" class="btn btn-dk btn-full" style="text-align:center;display:block">Start Shopping</a></div>';
    footer.innerHTML = '';
    return;
  }
  items.innerHTML = cart.items.map((item, idx) => `
    <div class="cditem">
      <img class="cdimg" src="${item.image}" alt="${item.title}" />
      <div class="cdinfo">
        <div class="cdn">${item.product_title}</div>
        <div class="cds">Size: ${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
        <div class="cdp">${fmtMoney(item.line_price)}</div>
        <div class="cdqty">
          <button class="cdqbtn" onclick="cartLine(${idx+1},${item.quantity-1})">&#8722;</button>
          <span class="cdqn">${item.quantity}</span>
          <button class="cdqbtn" onclick="cartLine(${idx+1},${item.quantity+1})">&#43;</button>
        </div>
      </div>
      <button class="cdrm" onclick="cartLine(${idx+1},0)" title="Remove">&#10005;</button>
    </div>`).join('');
  const free = cart.total_price >= 99900;
  footer.innerHTML = `
    <div class="cdsub"><span>Subtotal</span><span>${fmtMoney(cart.total_price)}</span></div>
    <p class="cdnote">${free ? 'You qualify for free shipping! 🎉' : 'Add ₹' + ((99900 - cart.total_price)/100).toFixed(0) + ' more for free delivery.'}</p>
    <a href="/checkout" class="btn btn-dk btn-full" style="text-align:center;display:block;margin-bottom:10px">Checkout &mdash; ${fmtMoney(cart.total_price)}</a>
    <button class="btn btn-ol btn-full" onclick="closeCartDrawer()" style="display:block;width:100%;text-align:center">Continue Shopping</button>`;
}
async function cartLine(line, qty) {
  await MonoraCart.change(line, qty);
  await refreshCartDrawer();
  if (document.querySelector('.cartpg')) location.reload();
}

// ── ADD TO CART ──
async function addVariantToCart(variantId) {
  if (!variantId) { showToast('Please select a size'); return; }
  const btn = document.getElementById('addCartBtn');
  if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
  try {
    await MonoraCart.add([{id: parseInt(variantId), quantity: 1}]);
    await refreshCartDrawer();
    openCartDrawer();
    showToast('Added to your bag!');
  } catch(e) {
    showToast('Could not add to cart. Please try again.');
  } finally {
    if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
  }
}

// Quick add from grid card
async function quickAdd(variantId, name, size) {
  await MonoraCart.add([{id: parseInt(variantId), quantity: 1}]);
  await refreshCartDrawer();
  openCartDrawer();
  showToast(name + ' (' + size + ') added!');
}

// ── WISHLIST (localStorage) ──
const Wishlist = {
  _key: 'monora_wishlist',
  get()  { try { return new Set(JSON.parse(localStorage.getItem(this._key)||'[]')); } catch { return new Set(); } },
  save(s){ localStorage.setItem(this._key, JSON.stringify([...s])); },
  has(id){ return this.get().has(String(id)); },
  toggle(id) {
    const s = this.get(), sid = String(id);
    if (s.has(sid)) { s.delete(sid); showToast('Removed from wishlist'); }
    else            { s.add(sid);    showToast('Saved to wishlist!'); }
    this.save(s);
    this.updateBadge();
    this.updateBtn(id);
  },
  updateBadge() {
    const b = document.getElementById('wishBadge');
    const c = this.get().size;
    if (b) { b.textContent = c; b.style.display = c > 0 ? 'flex' : 'none'; }
  },
  updateBtn(id) {
    const on = this.has(id);
    document.querySelectorAll('[data-wish="'+id+'"]').forEach(btn => {
      btn.classList.toggle('on', on);
    });
  }
};
function toggleWish(id) { Wishlist.toggle(id); }

// ── MOBILE MENU ──
function openMM()  { document.getElementById('mmOv').classList.add('open'); document.getElementById('mmDr').classList.add('open'); }
function closeMM() { document.getElementById('mmOv').classList.remove('open'); document.getElementById('mmDr').classList.remove('open'); }

// ── SIZE CHART ──
function openSC()  { document.getElementById('scModal').classList.add('open'); }
function closeSC() { document.getElementById('scModal').classList.remove('open'); }

// ── TOAST ──
let _tt;
function showToast(msg) {
  const el = document.getElementById('toast');
  if (!el) return;
  el.textContent = msg; el.classList.add('show');
  clearTimeout(_tt); _tt = setTimeout(() => el.classList.remove('show'), 2800);
}

// ── PRODUCT PAGE ──
function initPDP() {
  let selVariant = null;
  const addBtn = document.getElementById('addCartBtn');
  const wishBtn = document.getElementById('pdpWishBtn');
  const productId = document.getElementById('pdpProductId')?.value;

  // Size pills
  document.querySelectorAll('.szpill').forEach(btn => {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.szpill').forEach(b => b.classList.remove('on'));
      this.classList.add('on');
      selVariant = this.dataset.variantId;
      if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Add to Cart'; }
    });
  });

  // Add to cart
  if (addBtn) {
    addBtn.addEventListener('click', () => addVariantToCart(selVariant));
  }

  // Wishlist
  if (wishBtn && productId) {
    if (Wishlist.has(productId)) wishBtn.classList.add('on');
    wishBtn.addEventListener('click', () => {
      Wishlist.toggle(productId);
      wishBtn.classList.toggle('on', Wishlist.has(productId));
    });
  }

  // Thumbnails
  document.querySelectorAll('.pdpth').forEach(thumb => {
    thumb.addEventListener('click', function() {
      const mainImg = document.getElementById('pdpMainImg');
      if (mainImg) mainImg.src = this.dataset.src;
      document.querySelectorAll('.pdpth').forEach(t => t.classList.remove('on'));
      this.classList.add('on');
    });
  });
}

// ── NEWSLETTER ──
function nlSubmit(e) {
  e.preventDefault();
  showToast('Welcome to the Monorā circle! ✨');
  e.target.reset();
}

// ── INIT ──
document.addEventListener('DOMContentLoaded', async () => {
  // Cart badge
  try {
    const cart = await MonoraCart.get();
    updateCartBadge(cart.item_count);
  } catch(e) {}

  // Wishlist badge + card buttons
  Wishlist.updateBadge();
  Wishlist.get().forEach(id => {
    document.querySelectorAll('[data-wish="'+id+'"]').forEach(b => b.classList.add('on'));
  });

  // PDP
  if (document.getElementById('addCartBtn')) initPDP();

  // ESC
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { closeCartDrawer(); closeMM(); closeSC(); }
  });
});
